import Spinner from 'react-bootstrap/Spinner'

const DownloadProgress = ({ showSignal, messageSignal }) => {
	return showSignal.value ? (
		<div className="d-flex flex-column align-items-center justify-content-center" data-title="Downloading...">
			<Spinner className="mt-5" animation="border" role="status">
				<span className="visually-hidden">{messageSignal.value}</span>
			</Spinner>
			<p className="mt-3">{messageSignal.value}</p>
		</div>
	) : <></>
}
export default DownloadProgress